import React from 'react';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { getFormatIcon, getFormatName } from 'shared/lib/utils/utils';
import IconLink from 'shared/icons/link';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export enum SpecialTypes {
  TABLE = 'table',
}

export default function ItemFormatCell({ format }: { format: string }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const icon = getFormatIcon({ format });

  const { isLessLaptop } = useBooleanScreens();

  return format === SpecialTypes.TABLE ? (
    <CellContainer
      sx={{
        flexShrink: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        gap: sp.s20,
      }}
    >
      <IconLink></IconLink>
    </CellContainer>
  ) : (
    <CellContainer sx={{ flexShrink: 0, overflow: 'visible' }}>
      <Box
        sx={{
          display: 'flex',
          gap: sp.s20,
          alignItems: 'center',
          svg: {
            position: 'relative',
            top: '-10%',
          },
        }}
      >
        {icon}
        {isLessLaptop ? null : (
          <Typography
            title={getFormatName({ format })}
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            variant="f14"
            color="text.secondary"
          >
            {getFormatName({ format })}
          </Typography>
        )}
      </Box>
    </CellContainer>
  );
}
